<template>
	<div class="plugins-cards">
		<CardsPicker />
		<div class="cards-info" v-if="cardsStore.businessCards && cardsStore.businessCards.length > 0">
			<div class="cards-selector-container">
				<CardsSelector />
			</div>
			<div class="card-chart-container">
				<CardsShipmentInfo v-if="shouldShowShipmentInfo" />
				<CardsChart v-else />
			</div>
		</div>
		<div class="card-transactions-tables mt-30" v-if="cardsStore.activeCardId">
			<CardsTransactionsTable :card-id="cardsStore.activeCardId" />
		</div>
	</div>
</template>

<script>
import CardsPicker from "@/console-new/components/config/administration/cards/CardsPicker.vue";
import CardsSelector from "@/console-new/components/config/administration/cards/CardsSelector.vue";
import CardsChart from "@/console-new/components/config/administration/cards/CardsChart.vue";
import CardsShipmentInfo from "@/console-new/components/config/administration/cards/CardsShipmentInfo.vue";
import CardsTransactionsTable from "@/console-new/components/config/administration/cards/CardsTransactionsTable.vue";
import {useCardsStore} from "@/console-new/stores/cards.store";
import {useLanguageStore, useScriptStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores";

export default {
	setup() {
		const cardsStore = useCardsStore();
		const languageStore = useLanguageStore();
		const userStore = useUserStore();
		const scriptStore = useScriptStore();
		return {
			cardsStore,
			languageStore,
			scriptStore,
			userStore
		}
	},
	name: "CardsManagementContainer",
	components: {CardsTransactionsTable, CardsChart, CardsShipmentInfo, CardsSelector, CardsPicker},
	computed: {
		shouldShowShipmentInfo() {
			if (!this.cardsStore.activeCardId || !this.cardsStore.businessCards) {
				return false;
			}
			const activeCard = this.cardsStore.businessCards.find(card => card.card_id === this.cardsStore.activeCardId);
			if (!activeCard) {
				return false;
			}
			let delivered = activeCard.shipment_status === 'delivered' || (activeCard.shipment_status === "shipped" && !activeCard.shipment_tracking);
			return activeCard.type === 'physical' && !delivered;
		}
	},
	mounted() {
		this.cardsStore.getBusinessCards();
	},
	watch: {
		'userStore.currBusinessId': function (newVal, oldVal) {
			if (newVal !== oldVal) {
				this.cardsStore.getBusinessCards();
			}
		},
		'cardsStore.businessCards': function (newVal) {
			if (newVal && newVal.length > 0) {
				this.scriptStore.loadScript("stripe", () => {})
			}
		}
	}
}
</script>

<style scoped lang="scss">
.plugins-cards {
	display: flex;
	flex-direction: column;
}
.cards-info {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: stretch;
	gap: 20px;

	@media (max-width: 1024px) {
		flex-direction: column;
	}

	.cards-selector-container {
		width: 50%;

		@media (max-width: 1024px) {
			width: 100%;
		}
	}

	.card-chart-container {
		width: calc(50% - 20px);

		@media (max-width: 1024px) {
			width: 100%;
		}
	}
}
</style>